import React, { useState, useEffect } from "react";

const GridGenerator = ({ buildingDetails, onUpdate, disabled }) => {
  // console.log(">>buildingDetails",buildingDetails)
  // console.log(">>onUpdate",onUpdate)
  // console.log(">>disabled",disabled)

  const gridRows = parseInt(buildingDetails?.lengthBays) || 5;
  const gridCols = parseInt(buildingDetails?.widthBays) || 5;

  const [lengthValues, setLengthValues] = useState([]);
  const [widthValues, setWidthValues] = useState([]);
  const [backLengthValues, setBackLengthValues] = useState([]);
  const [rightWidthValues, setRightWidthValues] = useState([]);

  useEffect(() => {
    // LEFT WALL - reverse to match grid rendering (top=highest row, bottom=row1)
    if (buildingDetails?.wallsPayload?.["Left Side Wall"]?.length > 0) {
      const values = buildingDetails.wallsPayload["Left Side Wall"].map(
        (row) => parseFloat(row.cellSize || row.baySpacing) || 0,
      );
      setLengthValues([...values].reverse()); // ✅ reverse here
    } else {
      const cellLength =
        (parseInt(buildingDetails?.widthInMM) / 1000 || 5000) / gridRows;
      setLengthValues(Array.from({ length: gridRows }, () => cellLength));
    }

    // RIGHT WALL - reverse to match grid rendering
    if (buildingDetails?.wallsPayload?.["Right Side Wall"]?.length > 0) {
      const values = buildingDetails.wallsPayload["Right Side Wall"].map(
        (row) => parseFloat(row.cellSize || row.baySpacing) || 0,
      );
      setRightWidthValues([...values].reverse()); // ✅ reverse here
    } else {
      const cellWidth =
        (parseInt(buildingDetails?.widthInMM) / 1000 || 5000) / gridRows;
      setRightWidthValues(Array.from({ length: gridRows }, () => cellWidth));
    }

    // FRONT WALL - no change needed
    if (buildingDetails?.wallsPayload?.["Front End Wall"]?.length > 0) {
      setWidthValues(
        buildingDetails.wallsPayload["Front End Wall"].map(
          (row) => parseFloat(row.cellSize || row.baySpacing) || 0,
        ),
      );
    } else {
      const cellWidth =
        (parseInt(buildingDetails?.lengthInMM) / 1000 || 5000) / gridCols;
      setWidthValues(Array.from({ length: gridCols }, () => cellWidth));
    }

    // BACK WALL - no change needed
    if (buildingDetails?.wallsPayload?.["Back End Wall"]?.length > 0) {
      setBackLengthValues(
        buildingDetails.wallsPayload["Back End Wall"].map(
          (row) => parseFloat(row.cellSize || row.baySpacing) || 0,
        ),
      );
    } else {
      const cellLength =
        (parseInt(buildingDetails?.lengthInMM) / 1000 || 5000) / gridCols;
      setBackLengthValues(Array.from({ length: gridCols }, () => cellLength));
    }
  }, [buildingDetails, gridRows, gridCols]);

 const handleChange = (type, index, value) => {
  const newValue = parseFloat(value) || 0;
  let total = 0,
    currentValues = [];

  switch (type) {
    case "length":
      total = parseInt(buildingDetails?.widthInMM) / 1000 || 0;
      currentValues = [...lengthValues];
      break;
    case "width":
      total = parseInt(buildingDetails?.lengthInMM) / 1000 || 0;
      currentValues = [...widthValues];
      break;
    case "backLength":
      total = parseInt(buildingDetails?.lengthInMM) / 1000 || 0;
      currentValues = [...backLengthValues];
      break;
    case "rightWidth":
      total = parseInt(buildingDetails?.widthInMM) / 1000 || 0;
      currentValues = [...rightWidthValues];
      break;
    default:
      return;
  }

  const remainingSpace = total - newValue;
  const remainingBays = currentValues.length - 1;

  const newValues = currentValues.map((val, i) => {
    if (i === index) return newValue;
    return remainingBays > 0 ? remainingSpace / remainingBays : val;
  });

  switch (type) {
    case "length":
      setLengthValues(newValues);
      break;
    case "width":
      setWidthValues(newValues);
      break;
    case "backLength":
      setBackLengthValues(newValues);
      break;
    case "rightWidth":
      setRightWidthValues(newValues);
      break;
    default:
      break; // ✅ added default case to fix the ESLint warning
  }

  // ✅ For left/right walls, reverse the index back before calling onUpdate
  const isReversed = type === "length" || type === "rightWidth";
  const totalItems = newValues.length;

  newValues.forEach((val, i) => {
    const updateIndex = isReversed ? totalItems - 1 - i : i;
    onUpdate?.(type, updateIndex, val.toFixed(3));
  });
};

  if (!buildingDetails) return null;

  const rowArray = Array.from({ length: gridRows }, (_, i) => gridRows - i + 1);

  const colArray = Array.from({ length: gridCols + 1 }, (_, i) => {
    const alphabet = "ABCDEFGHJKLMNPQRSTUVWXYZ"; // I and O removed (24 letters)
    const base = alphabet.length; // 24

    let num = i;
    let label = "";

    while (num >= 0) {
      const index = num % base;
      label = alphabet[index] + label;
      num = Math.floor(num / base) - 1;
    }

    return label;
  });

  return (
    <div
      style={{
        padding: "20px",
        position: "relative",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      {/* WALL LABELS */}
      <div
        style={{
          position: "absolute",
          top: "30px",
          textAlign: "center",
          fontWeight: "bold",
          color: "red",
        }}
      >
        BACK END WALL (BEW)
      </div>
      <div
        style={{
          position: "absolute",
          left: "-4px",
          top: "69%",
          transform: "translateY(-50%) rotate(-90deg)",
          transformOrigin: "left top",
          fontWeight: "bold",
          color: "red",
          whiteSpace: "nowrap",
        }}
      >
        LEFT SIDE WALL (LSW)
      </div>
      <div
        style={{
          position: "absolute",
          right: "-4px",
          top: "75%",
          transform: "translateY(-50%) rotate(90deg)",
          transformOrigin: "right top",
          fontWeight: "bold",
          color: "red",
          whiteSpace: "nowrap",
        }}
      >
        RIGHT SIDE WALL (RSW)
      </div>
      <div
        style={{
          position: "absolute",
          bottom: "30px",
          textAlign: "center",
          fontWeight: "bold",
          color: "red",
        }}
      >
        FRONT SIDE WALL (FSW)
      </div>

      <div
        style={{
          border: "2px solid black",
          padding: "10px",
          position: "relative",
          overflowX: "auto",
          maxWidth: "100%",
          marginTop: "40px",
          marginBottom: "40px",
          paddingTop: "50px",
        }}
      >
        <div
          style={{
            minWidth: `${80 + gridCols * 100 + 80 + 120}px`,
            position: "relative",
            marginLeft: "60px",
            marginBottom: "60px",
          }}
        >
          {/* Rows */}
          {rowArray.map((rowNumber, rIdx) => (
            <div key={rIdx} style={{ display: "flex", position: "relative" }}>
              {/* LEFT WALL */}
              <div
                style={{
                  width: "80px",
                  borderRight: "1px dotted black",
                  borderTop: "1px dotted black",
                  position: "relative",
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    top: "0",
                    left: "-40px",
                    width: "40px",
                    borderTop: "1px dotted black",
                  }}
                ></div>
                <div
                  style={{
                    border: "2px solid black",
                    borderRadius: "50%",
                    width: "28px",
                    height: "28px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: "12px",
                    position: "absolute",
                    left: "-58px",
                    top: "0%",
                    transform: "translateY(-50%)",
                    background: "white",
                  }}
                >
                  {rowNumber}
                </div>
                <input
                  type="number"
                  value={lengthValues[rIdx] || ""}
                  onChange={(e) => handleChange("length", rIdx, e.target.value)}
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "0px",
                    transform: "translateY(-50%)",
                    border: "1px solid black",
                    padding: "2px 6px",
                    background: "white",
                    fontSize: "12px",
                    width: "70px",
                    textAlign: "center",
                  }}
                  disabled={disabled}
                />
              </div>

              {/* Grid Cells */}
              {Array.from({ length: gridCols }, (_, cIdx) => (
                <div
                  key={cIdx}
                  style={{
                    width: "100px",
                    height: "60px",
                    borderTop: "1px dotted black",
                    borderLeft: "1px dotted black",
                    borderRight:
                      cIdx === gridCols - 1 ? "1px dotted black" : "none",
                    position: "relative",
                  }}
                >
                  {cIdx === gridCols - 1 && (
                    <>
                      <div
                        style={{
                          position: "absolute",
                          top: "0%",
                          right: "-40px",
                          width: "40px",
                          borderTop: "1px dotted black",
                          transform: "translateY(-50%)",
                        }}
                      ></div>
                      <input
                        type="number"
                        value={rightWidthValues[rIdx] || ""}
                        onChange={(e) =>
                          handleChange("rightWidth", rIdx, e.target.value)
                        }
                        style={{
                          position: "absolute",
                          top: "50%",
                          right: "-80px",
                          transform: "translateY(-50%)",
                          border: "1px solid black",
                          padding: "2px 6px",
                          background: "white",
                          fontSize: "12px",
                          width: "70px",
                          textAlign: "center",
                        }}
                        disabled={disabled}
                      />
                    </>
                  )}
                </div>
              ))}
            </div>
          ))}

          {/* Bottom row */}
          <div style={{ display: "flex", position: "relative" }}>
            <div
              style={{
                width: "120px",
                borderTop: "1px dotted black",
                position: "relative",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  left: "-30px",
                  top: "100%",
                  width: "30px",
                  borderTop: "1px dotted black",
                }}
              ></div>
              <div
                style={{
                  border: "2px solid black",
                  borderRadius: "50%",
                  width: "28px",
                  height: "28px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "12px",
                  position: "absolute",
                  left: "-58px",
                  top: "100%",
                  background: "white",
                  transform: "translateY(-50%)",
                  fontWeight: "bold",
                }}
              >
                1
              </div>
            </div>
            {Array.from({ length: gridCols }, (_, idx) => (
              <div
                key={idx}
                style={{
                  width: "100px",
                  borderTop: "1px dotted black",
                  borderLeft: "1px dotted black",
                  height: "0px",
                }}
              ></div>
            ))}
          </div>

          {/* Column labels and inputs */}
          <div style={{ display: "flex" }}>
            <div style={{ width: "80px" }}></div>
            {colArray.map((col, idx) => (
              <div
                key={idx}
                style={{
                  width: "100px",
                  textAlign: "center",
                  borderLeft: "1px dotted black",
                  padding: "5px",
                  position: "relative",
                }}
              >
                {/* Lines */}
                <div
                  style={{
                    position: "absolute",
                    bottom: "-30px",
                    left: "0%",
                    width: "1px",
                    height: "30px",
                    borderLeft: "1px dotted black",
                    transform: "translateX(-50%)",
                  }}
                ></div>
                <div
                  style={{
                    position: "absolute",
                    top: `${-(gridRows * 60 + 30)}px`,
                    left: "0%",
                    width: "1px",
                    height: "30px",
                    borderLeft: "1px dotted black",
                    transform: "translateX(-50%)",
                  }}
                ></div>

                {/* Circle */}
                <div
                  style={{
                    border: "2px solid black",
                    borderRadius: "28px",
                    width: "28px",
                    height: "28px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: "12px",
                    background: "yellow",
                    position: "absolute",
                    bottom: "-58px",
                    left: "0%",
                    transform: "translateX(-50%)",
                  }}
                >
                  {col}
                </div>

                {/* FRONT WALL INPUT */}
                {idx < gridCols && (
                  <input
                    type="number"
                    value={widthValues[idx] || ""}
                    onChange={(e) => handleChange("width", idx, e.target.value)}
                    style={{
                      position: "absolute",
                      top: "200%",
                      right: "13px",
                      transform: "translateY(-50%)",
                      border: "1px solid black",
                      padding: "2px 6px",
                      background: "white",
                      width: "70px",
                      textAlign: "center",
                    }}
                    disabled={disabled}
                  />
                )}

                {/* BACK WALL INPUT */}
                {idx < gridCols && (
                  <input
                    type="number"
                    value={backLengthValues[idx] || ""}
                    onChange={(e) =>
                      handleChange("backLength", idx, e.target.value)
                    }
                    style={{
                      position: "absolute",
                      top: `${-(gridRows * 60 + 30)}px`,
                      left: "55%",
                      transform: "translateX(-50%)",
                      border: "1px solid black",
                      padding: "2px 6px",
                      background: "white",
                      width: "70px",
                      textAlign: "center",
                    }}
                    disabled={disabled}
                  />
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GridGenerator;
